import type { PublicTrip } from "@busbud/core-types/dist/lib/poll-service/api";

import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";

export function getPurchaseTrip(purchase: NapiV2Purchase): PublicTrip {
  // For some reason the API was designed to support multiple trips but only one will be present
  // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return Object.values(purchase.trips)[0];
}
